import { Helmet } from "react-helmet-async";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import EventsHero from "./components/EventsHero";
import UpcomingEvents from "./components/UpcomingEvents";
import PastEvents from "./components/PastEvents";

export default function EventsPage() {
  return (
    <main>
      <Helmet>
        <title>Investment Events in East Africa | Conferences & Summits | AIP</title>
        <meta name="description" content="Stay updated on upcoming investment events, business conferences, and economic summits across East Africa. Connect with investors, entrepreneurs, and policymakers." />
        <meta name="keywords" content="investment events East Africa, business conferences Africa, economic summits East Africa, investor networking Africa, Rwanda investment summit, Kenya investment forum" />
        <link rel="canonical" href="https://africainvestmentportal.com/events" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Investment Events in East Africa | Conferences & Summits" />
        <meta property="og:description" content="Upcoming investment events, business conferences, and economic summits across East Africa." />
        <meta property="og:url" content="https://africainvestmentportal.com/events" />
        <meta property="og:image" content="https://africainvestmentportal.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Investment Events in East Africa | Conferences & Summits" />
        <meta name="twitter:description" content="Upcoming investment events, business conferences, and economic summits across East Africa." />
      </Helmet>
      <Navbar />
      <EventsHero />
      <UpcomingEvents />
      <PastEvents />
      <Footer />
    </main>
  );
}
